import type { ChangeEvent } from 'react';
import { useForm, FormProvider } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";

import { Wrench } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { usePostAccidentRepairer, type AjoutReparateurValues } from '@/hooks/api/use-accidents';
import type { Accident } from '@/types/api/accident';
import FormAjoutReparateur from "@/pages/accident/sinistre/ajout-reparateur/form-ajout-reparateur";

const initialValues: AjoutReparateurValues = {
    reparateur: '',
    cpreparateur: '',
    visit: ''
};

interface AjoutReparateurProps {
    accident: Accident;
}

const AjoutReparateur = ({ accident }: AjoutReparateurProps) => {
    const { id, ids } = useParams();
    const navigate = useNavigate();
    const redirect_url = `/mes-sinistres/contrat/${id}/sinistre/${ids}`;
    const { mutate: postAccidentRepairer, isPending: loading } = usePostAccidentRepairer();

    const methods = useForm<AjoutReparateurValues>({
        defaultValues: initialValues,
    });

    const { handleSubmit, watch, formState: { errors }, setValue } = methods;
    const values = watch();

    const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setValue(name, value);
    };

    return (
        <FormProvider {...methods}>
            <form onSubmit={handleSubmit(values => postAccidentRepairer({accidentId: String(ids), form: values, successFunction: () => navigate(redirect_url)}))}>
                <Card>
                    <CardHeader className="pb-6 border-b">
                        <CardTitle className="text-lg flex items-center gap-2">
                            <Wrench className="w-5 h-5 text-primary" />
                            Votre réparateur
                        </CardTitle>
                    </CardHeader>
                    <CardContent className="pt-6 space-y-6">
                        <FormAjoutReparateur
                            accident={accident}
                            errors={errors}
                            values={values}
                            setValue={setValue}
                            handleChange={handleChange}
                        />

                        <Button
                            type="submit"
                            className="w-full cursor-pointer text-white"
                            disabled={!values.reparateur}
                            loading={loading}
                            loadingText="Enregistrement en cours..."
                        >
                            Je valide mes informations personnelles
                        </Button>
                    </CardContent>
                </Card>
            </form>
        </FormProvider>
    );
};

export default AjoutReparateur;
